import React, { Component } from 'react';
import moment from 'moment';
import Axios from 'axios';
import classNames from 'classnames';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import getPath from 'lodash/get';
import { basicManager, publisherManager } from '../../../../helpers/managers';
import { stripeSupportedCountries } from '../../../../helpers/payments';
import parseQueryParams from '../../../../helpers/parseQueryParams';
import userTour from '../../../../helpers/tour';
import sharedStyles from '../shared/styles';
import ImageArt from '../soundcast/imageart';
import { RowDivision, DivisionLabel } from '../shared/styled-components';
import ImageCropModal from '../../../../components/ImageCropModal';
import Loading from '../../../../components/Loading';
import Colors from '../../../../styles/colors';
import commonStyles from '../../../../styles/commonStyles';
import { InputLabel, InputText, InputTextArea, Select } from '../../../../styles/styled';
import {
  OrangeSubmitButton,
  TransparentShortSubmitButton,
} from '../../../../components/buttons/buttons';
import Admin from './admin';

const clientId = process.env.NODE_ENV === 'production'
  ? 'ca_BwcFxIj5tpCcv3JqmXy7usb88tBSBRD4'   // live account
  : 'ca_BwcFWisx5opzCTEBnz5M16ss7Oj6VKeK';  // test account
const redirectURI =
  process.env.NODE_ENV === 'dev'
    ? `http://localhost:3000/dashboard/publisher&client_id=${clientId}`
    : process.env.NODE_ENV === 'staging'
    ? `https://preprod.mysoundwise.com/dashboard/publisher&client_id=${clientId}`
    : `https://app.mysoundwise.com/dashboard/publisher&client_id=${clientId}`;

export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      publisherName: '',
      publisherImg: '',
      publisherEmail: '',
      stripe_user_id: null,
      authorized: false,
      creatingAccount: false,
      imagecrop: {
        show: false,
        onCrop: () => {},
        onClose: () => {},
        file: null,
      },
    };

    this.loadFromProp = this.loadFromProp.bind(this);
    this.handleStripeRedirect = this.handleStripeRedirect.bind(this);
    this.requestStripeDashboard = this.requestStripeDashboard.bind(this);
    this.onInputStateChange = this.onInputStateChange.bind(this);
    this.openImageCropModal = this.openImageCropModal.bind(this);
    this.closeImageCropModal = this.closeImageCropModal.bind(this);
    this.initFilepondImageCropperFor = this.initFilepondImageCropperFor.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    if (this.props.userInfo.publisher) {
      this.loadFromProp(this.props.userInfo);
      this.handleStripeRedirect(this.props.userInfo.publisherID, this.props.userInfo);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.userInfo.soundcasts_managed &&
      nextProps.userInfo.publisher &&
      nextProps != this.props
    ) {
      const { userInfo } = nextProps;
      this.loadFromProp(userInfo);
      this.handleStripeRedirect(userInfo.publisherID, userInfo);
    }
  }

  onInputStateChange(statekey) {
    return e => {
      const value = e.target.value;
      this.setState({
        [statekey]: value,
      });
    };
  }

  // handle stripe re-direct
  handleStripeRedirect(publisherId, userInfo) {
    const queryString = window.location.search;
    if (!this.handleStripeRedirectCalledLock && queryString.length > 0) {
      this.handleStripeRedirectCalledLock = true; // ensure handleStripeRedirect called only once
      const params = parseQueryParams(queryString);
      // console.log('handleStripeRedirect params:', params);
      if (params.state == publisherId && !this.state.authorized && !this.state.creatingAccount) {
        this.setState({ creatingAccount: true });
        Axios.post('/api/create_stripe_account', {
          code: params.code,
          publisherId,
          publisherPlan: getPath(userInfo, 'publisher.plan', null),
        })
          .then(res => {
            const { status, data } = res || {};
            const { success = false, errorMessage, stripe_user_id, stripe_connect_type } = data || {};
            if (!success) {
              throw new Error(errorMessage);
            }
            this.setState(
              {
                stripe_user_id,
                authorized: true,
                creatingAccount: false,
              },
              () => {
                if (!isEmpty(userInfo) && !isEmpty(userInfo.publisher)) {
                  userInfo.publisher.stripe_user_id = stripe_user_id;
                  userInfo.publisher.stripe_connect_type = stripe_connect_type;
                  this.loadFromProp(userInfo);
                }
              }
            );
          })
          .catch(err => {
            const message = getPath(err, 'response.data.errorMessage', err.message);
            this.setState({ creatingAccount: false },
              () => {
                const brKey = `br-show-err-${moment().format('X')}`;
                this.props.showAlertModal({
                  content: [
                    'There was a problem saving publisher data. ',
                    'Please contact support at support@mysoundwise.com if the issue persists.',
                    <br key={`${brKey}-1`} />,
                    <br key={`${brKey}-2`} />,
                    message || 'Unknown error',
                  ],
                  cancel: false,
                });
              }
            );
          });
      }
    }
  }

  loadFromProp(userInfo) {
    if (userInfo.publisher) {
      const publisherId = userInfo.publisherID;
      const {
        name,
        imageUrl,
        email,
        stripe_user_id,
        publisherInfo,
        website,
        facebook,
        twitter,
        linkedin,
        instagram,
      } = userInfo.publisher;
      const { publisherName, publisherImg, publisherEmail } = this.state;

      // if stripe already connected, complete the tour
      if (!isEmpty(stripe_user_id) && userTour.available()) {
        userTour.getTour().cancelTour();
        userTour.setUserProp('stripeConnected', true);
      }

      this.setState({
        publisherName: name || publisherName,
        publisherImg: imageUrl || publisherImg,
        publisherEmail: email || publisherEmail,
        publisherId,
        stripe_user_id,
        publisherInfo: publisherInfo || '',
        website: website || '',
        facebook: facebook || '',
        twitter: twitter || '',
        linkedin: linkedin || '',
        instagram: instagram || '',
      });

      if (!isEmpty(stripe_user_id)) {
        Axios.post('/api/check_stripe_account', {
          stripe_user_id,
          publisherId,
        })
          .then(res => {
            const { data = {}, status = 0 } = res || {};
            const { success = false, errorMessage = '' } = data;
            const stripeError = success
              ? ''
              :  `Stripe error found: ${errorMessage || 'unknown error'}`;
            this.setState({ stripeError });
          })
          .catch(err => console.log('stripe client posting error: ', err));
      }
    }
  }

  renderImageCropModal() {
    const { show, onCrop, onClose, file } = this.state.imagecrop;

    return <ImageCropModal open={show} handleClose={onClose} onCrop={onCrop} file={file} />;
  }

  openImageCropModal(metadata) {
    this.setState({
      imagecrop: {
        show: true,
        onClose: this.closeImageCropModal,
        ...metadata,
      },
    });
  }

  closeImageCropModal() {
    this.openImageCropModal({
      show: false,
    });
  }

  initFilepondImageCropperFor(options) {
    this.openImageCropModal(
      options({
        close: this.closeImageCropModal,
      })
    );
  }

  submit() {
    this.setState({ saving: true }, () => {
      const {
        publisherImg,
        publisherName,
        publisherId,
        publisherEmail,
        publisherInfo,
        website,
        facebook,
        twitter,
        linkedin,
        instagram,
      } = this.state;

      if (isEmpty(publisherName)) {
        return this.props.showAlertModal({
          content: 'Publisher name cannot be empty.',
          cancel: false,
          onClose: () => this.setState({ saving: false }),
        });
      }

      if (isEmpty(publisherEmail)) {
        return this.props.showAlertModal({
          content: 'Publisher email cannot be empty.',
          cancel: false,
          onClose: () => this.setState({ saving: false }),
        });
      }

      const publisherMap = {
        name: publisherName,
        imageUrl: publisherImg,
        email: publisherEmail,
        publisherInfo,
        website,
        facebook,
        twitter,
        linkedin,
        instagram,
      };

      const revisedPublisher = Object.keys(publisherMap).reduce((final, key) => {
        final[`publishers/${publisherId}/${key}`] = publisherMap[key];
        return final;
      }, {});

      basicManager
        .update(revisedPublisher)
        .then(() => {
          this.setState({ saving: false }, () => {
            this.props.showAlertModal({
              content: 'Publisher profile successfully saved.',
              cancel: false,
            });
          });
        })
        .catch(err => {
          this.setState({ saving: false }, () => {
            this.props.showAlertModal({
              content:
                'There was a problem saving publisher data. Please contact support at support@mysoundwise.com',
              cancel: false,
            });
          });
          console.log(err);
        });
    });
  }

  isLoggedInUserOwner() {
    const { userInfo } = this.props;
    const ownerId = getPath(userInfo, 'publisher.owner', '');
    if (isEmpty(ownerId)) {
      return false;
    }

    const { id: userId = '' } = userInfo;
    return isEqual(userId.trim(), ownerId.trim());
  }

  requestStripeDashboard() {
    const { publisher } = this.props.userInfo;
    if (publisher && publisher.stripe_connect_type === 'standard') {
      return window.open('https://dashboard.stripe.com/', '_blank'); // standard
    }

    // else express, old:
    let newWindow = window.open('', '_blank');
    newWindow.document.write('Loading...');
    Axios.post('/api/requestStripeDashboard', { stripe_user_id: this.state.stripe_user_id })
      .then(res => {
        // window.open(res.url, '_blank');
        newWindow.location.href = res.data.url;
      })
      .catch(err => {
        this.setState(
          {
            errorMessage: err.response.data,
          },
          () => {
            newWindow.document.write(err.response.data);
          }
        );
      });
  }

  handleStripeAuthUrl = publisherId => {
    return () => {
      // const expressStripeUrl = `https://connect.stripe.com/express/oauth/authorize?redirect_uri=${redirectURI}&state=${publisherID}`; // old
      const standardStripeUrl = `https://connect.stripe.com/oauth/authorize?redirect_uri=${redirectURI}&state=${publisherId}&scope=read_write&response_type=code`;
      window.location.href = standardStripeUrl;
    };
  };

  renderStripeBody() {
    const { stripe_user_id, creatingAccount, stripeError } = this.state;
    const { userInfo } = this.props;
    const { publisherID } = userInfo;

    if (stripe_user_id) {
      return (
        <>
          <div className="row margin-two-bottom">
            <div className="col-lg-7 col-md-7 col-xs-12 sm-text-center">
              <div className="stripe-status">
                <span
                  className="sm-display-none"
                  style={{ ...styles.titleText, color: 'green', marginRight: 15 }}>
                  <i className="fa fa-check" aria-hidden="true" />
                </span>
                <span style={styles.titleText}>Stripe Payout Account Connected</span>
              </div>
            </div>
            <div className="col-lg-5 col-md-5 col-xs-12">
              <div
                className="pull-right sm-float-none sm-text-center sm-font-weight-100 sm-padding-five"
                style={styles.titleText}
                onClick={this.requestStripeDashboard}>
                <span className="stripe-visit">{`View Payout Account >`}</span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-xs-12">
              <OrangeSubmitButton
                label={'Reconnect >'}
                onClick={this.handleStripeAuthUrl(publisherID)}
                styles={{
                  backgroundColor: 'transparent',
                  borderColor: Colors.softBlack,
                  width: '100%',
                  margin: '0px auto',
                  color: Colors.softBlack,
                }}
              />
            </div>
          </div>
          {stripeError && (
            <>
              <div className="row">
                <div className="col-lg-12 col-md-12 col-xs-12">
                  <InputTextArea
                    style={{ color: Colors.red, borderColor: Colors.red, minHeight: 64, marginTop: 4}}
                    readOnly={true}
                    value={stripeError}
                  />
                </div>
              </div>
            </>
          )}
        </>
      );
    }

    if (creatingAccount) {
      return (
        <>
          <InputLabel>Stripe Account</InputLabel>
          <Loading text="Finishing setup..." size={40} />
        </>
      );
    }

    return (
      <>
        <InputLabel>Set up Payouts with Stripe</InputLabel>
        <Select className="text-large no-margin" onChange={this.handleStripeAuthUrl(publisherID)}>
          <option value="">Choose your country</option>
          {stripeSupportedCountries.map((country, i) => {
            return (
              <option value={country.code} key={`${country.code}-${i}`}>
                {country.name}
              </option>
            );
          })}
        </Select>
      </>
    );
  }

  render() {
    const {
      publisherImg,
      publisherName,
      publisherInfo,
      website,
      facebook,
      twitter,
      linkedin,
      instagram,
      publisherEmail,
      saving,
    } = this.state;
    const { userInfo, usage } = this.props;
    const { publisherID } = userInfo;

    const inputs = [
      [
        {
          label: 'Profile Image',
          key: 'publisherImg',
          value: publisherImg,
          type: 'render',
          render: () => {
            return (
              <ImageArt
                value={publisherImg}
                autoSave={false}
                datakey="publisherImg"
                filename={`${moment().format('X')}p`}
                cropperHandler={this.initFilepondImageCropperFor}
                onChange={(key, value) => {
                  this.setState({
                    [key]: value,
                  });
                }}
                artStyle={{
                  wrapper: sharedStyles.coverArtUploader,
                  cover: sharedStyles.coverArt,
                  button: sharedStyles.uploadResourceButton,
                }}
                uploader={{
                  style: {
                    padding: 0,
                  },
                  options: {
                    imageValidateSizeMinWidth: 100,
                    imageValidateSizeMaxWidth: 3000,
                    imageValidateSizeMinHeight: 100,
                    imageValidateSizeMaxHeight: 3000,
                  },
                }}
              />
            );
          },
        },
      ],
      [
        {
          label: 'Name',
          key: 'publisherName',
          value: publisherName,
          onChange: this.onInputStateChange,
        },
        {
          label: 'Email',
          key: 'publisherEmail',
          value: publisherEmail,
          onChange: this.onInputStateChange,
        },
      ],
      [
        {
          label: 'Publisher Info',
          key: 'publisherInfo',
          value: publisherInfo,
          type: 'render',
          render: () => (
            <InputTextArea
              value={publisherInfo}
              onChange={this.onInputStateChange('publisherInfo')}
            />
          ),
        },
      ],
      [
        {
          label: 'Website',
          key: 'website',
          value: website,
          onChange: this.onInputStateChange,
        },
        {
          label: 'Facebook',
          key: 'facebook',
          value: facebook,
          onChange: this.onInputStateChange,
        },
      ],
      [
        {
          label: 'Twitter',
          key: 'twitter',
          value: twitter,
          onChange: this.onInputStateChange,
        },
        {
          label: 'LinkedIn',
          key: 'linkedin',
          value: linkedin,
          onChange: this.onInputStateChange,
        },
      ],
      [
        {
          label: 'Instagram',
          key: 'instagram',
          value: instagram,
          onChange: this.onInputStateChange,
        },
      ],
    ];

    return (
      <ProfileWrapper>
        <ProfileContainer>
          {inputs.map((items, ikey) => {
            return (
              <RowDivision className="row" key={`input-${ikey}`}>
                {items.map((input, subkey) => {
                  const { label, key, value = '', onChange, type = '', render = () => {} } = input;
                  const hasCustomRender = type === 'render';
                  const contentValue = hasCustomRender ? (
                    render()
                  ) : (
                    <InputText type="text" onChange={onChange(key)} value={value} />
                  );

                  const columnClass = classNames('col-sm-12 col-xs-12', {
                    'col-lg-12': hasCustomRender,
                    'col-md-12': hasCustomRender,
                    'col-lg-6': !hasCustomRender,
                    'col-md-6': !hasCustomRender,
                  });

                  return (
                    <div className={columnClass} key={`subkey-${subkey}`}>
                      <InputLabel>{label}</InputLabel>
                      {contentValue}
                    </div>
                  );
                })}
              </RowDivision>
            );
          })}

          <div className="row padding-bottom-20px padding-top-20px">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
              <div className="pull-left sm-float-none">
                <OrangeSubmitButton
                  label={saving ? 'Saving...' : 'Save'}
                  onClick={this.submit}
                  styles={{ margin: 0, backgroundColor: !saving ? Colors.mainOrange : '#fc9961' }}
                  className="sm-width-100"
                  disabled={saving}
                />
              </div>
              <div className="pull-right sm-float-none sm-padding-top-10px">
                <TransparentShortSubmitButton
                  label="Cancel"
                  onClick={() => this.loadFromProp(userInfo)}
                  styles={{ margin: 0 }}
                  className="sm-width-100"
                />
              </div>
            </div>
          </div>

          <AdvancedSection>
            <div className="row margin-three-bottom">
              <div id="stripe-connect-area" className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                {this.renderStripeBody()}
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <DivisionLabel>Administrators</DivisionLabel>
                {!isEmpty(publisherID) && (
                  <Admin
                    usage={usage}
                    publisherId={publisherID}
                    editMode={this.isLoggedInUserOwner()}
                    renderStartButton={toggleModal => {
                      return (
                        <OrangeSubmitButton
                          label="Manage Admins"
                          onClick={toggleModal}
                          styles={{
                            margin: 0,
                            textAlign: 'center',
                          }}
                          className="sm-width-100"
                        />
                      );
                    }}
                    onClickUpgrade={() => this.props.history.push('/pricing')}
                  />
                )}
              </div>
            </div>
          </AdvancedSection>
          {this.renderImageCropModal()}
        </ProfileContainer>
      </ProfileWrapper>
    );
  }
}

const ProfileWrapper = styled.div`
  padding: 30px;
  background: #fff;
`;

const ProfileContainer = styled.div`
  max-width: 720px;
`;

const AdvancedSection = styled.div`
  .stripe-status {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .stripe-visit {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const styles = {
  titleText: { ...commonStyles.titleText },
  inputTitle: { ...commonStyles.inputTitle, fontSize: 16 },
  categoryButton: { ...commonStyles.categoryButton },
  dropdownTitle: { ...commonStyles.dropdownTitle },
  uploadButton: {
    backgroundColor: Colors.link,
    width: 80,
    height: 30,
    // float: 'left',
    color: Colors.mainWhite,
    fontSize: 14,
    border: 0,
    marginTop: 5,
  },
  addAdmin: {
    fontSize: 16,
    // marginLeft: 10,
    marginTop: 20,
    marginBottom: 10,
    color: Colors.link,
    cursor: 'pointer',
  },
};
